
const digest = 'ceb98e9a982c23e5e35196a2b10337c137afe5c319af8e6eb3bf24774ebd24e6';
const css = `._connectButton_1ba0d_1 {
    width: 100%;
}
`;

(function() {
  if (typeof document === 'undefined') {
    return;
  }
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"connectButton":"_connectButton_1ba0d_1"};
export { css, digest };
  